import { createVanIconComponent } from "./van"

const Shrink = createVanIconComponent("shrink")
export default Shrink
